
import React, { useState } from 'react';
import { supabase } from '../lib/supabase';

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) setError(error.message);
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#020617] flex items-center justify-center p-6 relative overflow-hidden">
      <div className="absolute top-[-10%] left-[-10%] w-[50%] h-[50%] bg-blue-600/10 rounded-full blur-[120px] animate-pulse"></div>
      <div className="absolute bottom-[-10%] right-[-10%] w-[50%] h-[50%] bg-purple-600/10 rounded-full blur-[120px] animate-pulse delay-1000"></div>

      <div className="w-full max-w-md relative z-10 animate-in fade-in zoom-in-95 duration-700">
        <div className="glass p-12 rounded-[2.5rem] shadow-2xl text-center">
          <div className="w-20 h-20 bg-white/5 rounded-3xl mx-auto mb-8 flex items-center justify-center border border-white/10 shadow-inner">
            <img src="https://vinxbbpboupirnyxwghz.supabase.co/storage/v1/object/public/Ever-Music/file_00000000535c71f4a154bd2a598fddd0.png" className="w-12 h-12 object-contain" alt="Logo" />
          </div>
          
          <h1 className="text-4xl font-black text-white tracking-tighter mb-2 uppercase">Evern<span className="text-cyan-400">x</span></h1>
          <p className="text-slate-500 font-bold uppercase tracking-[0.3em] text-[9px] mb-12">Portal Authentication</p>

          {error && (
            <div className="bg-red-500/10 border border-red-500/20 text-red-400 p-4 rounded-2xl text-xs mb-8 flex items-center space-x-3 text-left">
              <i className="fas fa-circle-exclamation text-base"></i>
              <span>{error}</span>
            </div>
          )}

          <form onSubmit={handleLogin} className="space-y-6">
            <div className="space-y-1 text-left">
              <label className="text-[10px] font-black uppercase tracking-widest text-slate-500 ml-4">Email Address</label>
              <input 
                required 
                type="email" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)} 
                className="w-full bg-white/5 border border-white/5 text-white px-6 py-4 rounded-2xl focus:outline-none focus:ring-2 focus:ring-blue-500/30 transition-all font-semibold" 
                placeholder="name@company.com" 
              />
            </div>
            <div className="space-y-1 text-left">
              <label className="text-[10px] font-black uppercase tracking-widest text-slate-500 ml-4">Password</label>
              <input 
                required 
                type="password" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                className="w-full bg-white/5 border border-white/5 text-white px-6 py-4 rounded-2xl focus:outline-none focus:ring-2 focus:ring-purple-500/30 transition-all font-semibold" 
                placeholder="••••••••" 
              />
            </div>
            <button 
              disabled={loading} 
              type="submit" 
              className="w-full bg-blue-600 hover:bg-blue-500 text-white py-5 rounded-2xl font-black text-[11px] uppercase tracking-[0.2em] shadow-xl shadow-blue-600/20 transition-all hover:scale-[1.02] active:scale-95 disabled:opacity-50"
            >
              {loading ? 'Authenticating...' : 'Sign In Now'}
            </button>
          </form>
          
          <div className="mt-12 pt-8 border-t border-white/5 flex justify-between items-center text-[9px] font-black uppercase tracking-widest text-slate-700">
             <span>v1.0.4 Secure</span>
             <span>© EvernX 2024</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
